import { render, staticRenderFns } from "./BaseSelectableList.vue?vue&type=template&id=06db4143&scoped=true&"
import script from "./BaseSelectableList.vue?vue&type=script&lang=js&"
export * from "./BaseSelectableList.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectableList.vue?vue&type=style&index=0&id=06db4143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db4143",
  null
  
)

export default component.exports